import { canWithRoles, resolveStaffRoles } from "./permissions";

/**
 * Secciones del panel de plataforma para la **sidebar compartida** del shell
 * (`src/app/layout/`). El panel no monta navegación propia: reutiliza el mismo
 * `AppLayout` (navbar con logo, menú de usuario con "Cerrar sesión", sidebar
 * colapsable) que el resto de la app.
 *
 * Cada entrada declara el recurso de la matriz de staff (TASK-20) que necesita
 * LEER; la sección se muestra solo si el rol lo permite. Es gating de UX — el
 * backend responde 403 igual (ver ./permissions.js).
 */
const SUPERADMIN_NAV_ITEMS = [
  { to: "/superadmin/academias", icon: "mdi-domain", label: "Academias", resource: "companies" },
  { to: "/superadmin/suscripciones", icon: "mdi-autorenew", label: "Suscripciones", resource: "subscriptions" },
  { to: "/superadmin/facturas", icon: "mdi-receipt", label: "Facturas", resource: "invoices" },
  { to: "/superadmin/metricas", icon: "mdi-chart-line", label: "Métricas", resource: "metrics" },
  { to: "/superadmin/staff", icon: "mdi-shield-account-outline", label: "Staff y roles", resource: "staff" },
  { to: "/superadmin/bitacora", icon: "mdi-history", label: "Bitácora", resource: "audit" },
];

const SUPERADMIN_ROOT = "/superadmin";

/** ¿La ruta actual pertenece al panel de plataforma? */
function isSuperAdminPath(pathname) {
  return (
    pathname === SUPERADMIN_ROOT || Boolean(pathname?.startsWith(`${SUPERADMIN_ROOT}/`))
  );
}

/**
 * Entradas de sidebar permitidas para este usuario de staff.
 * `companies:read` lo tienen los 5 roles, así que solo sale vacío cuando el
 * usuario es staff sin ningún grupo asignado.
 */
function buildSuperAdminNavItems(user) {
  const staffRoles = resolveStaffRoles(user);
  return SUPERADMIN_NAV_ITEMS.filter((item) =>
    canWithRoles(staffRoles, item.resource, "read")
  );
}

export { SUPERADMIN_NAV_ITEMS, SUPERADMIN_ROOT, isSuperAdminPath, buildSuperAdminNavItems };
